import Swiper from 'swiper';
// import blueMediaBanner from "../../../../images/blue-media/bluemedia_banner_bw.png";
import axios from "axios";

import * as helpers from '../helpers';
import payForm from './form';
import validate from "./validate";

let swiper = null;
let account = false;
let idData = false;
const classHide = 'd-none';


export const showPanel = (show = true) => {
  const panel = document.querySelector('.microaccount-pay');
  if (!panel) return false;

  if (show) {
    const idDataGroup = panel.querySelector('.id-data');
    const accountInput = panel.querySelector('input[name="tax_account"]');
    if (idDataGroup) {
      idDataGroup.querySelector('label').innerText = idData.type === 1 ? 'PESEL' : 'NIP';
      idDataGroup.querySelector('input').name = idData.type === 1 ? 'pesel' : 'nip';
      idDataGroup.querySelector('input').value = idData.no;
    }
    if (accountInput) accountInput.value = account.raw;

    resetDataTypeBtns(0);
    if (idData.type === 2) dataTypeBtns(true);
    else dataTypeBtns(false);

    console.log('TYPE ID', idData);

    panel.classList.add('microaccount-pay-show');

    panel.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  else panel.classList.remove('microaccount-pay-show');
};

const dataTypeBtns = (show = true) => {
  const types = document.querySelector('#data-types');
  if (show) types.classList.remove(classHide);
  else types.classList.add(classHide);
};

export const fillAgain = () => {
  const form = document.querySelector('#microaccount-pay-form');
  if (!form) return false;

  showPanel(false);
  setTimeout(() => form.reset(), 300);
};

const addPanel = () => {
  let panelWrap = helpers.elementExist('.microaccount-box', true);
  if (!panelWrap) return false;

  if (helpers.elementExist('#microaccount-pay')) {
    return false;
  }

  // console.log('PANEL', panel);

  const form = document.createElement('form');
  form.id = 'microaccount-pay-form';
  form.classList.add('microaccount-pay-form');
  // form.action = '/bm/?test';
  form.action = '/bm/';
  form.method = 'post';

  const panel = document.createElement('div');
  panel.id = 'microaccount-pay';
  panel.classList.add('microaccount-pay', 'swiper-container');

  // const imgBM = document.createElement('img');
  // imgBM.src = blueMediaBanner;
  // imgBM.classList.add('img-responsive', 'bluemedia-banner', 'mt-2');

  panel.innerHTML = payForm(account);

  form.appendChild(panel);

  // form.querySelector('.fill-all').addEventListener('click', (e) => {
  //   e.preventDefault();
  //
  //   form.querySelector('[name="customer_first_name"]').value = 'Łukasz';
  //   form.querySelector('[name="customer_last_name"]').value = 'Testowy';
  //   form.querySelector('[name="customer_email"]').value = 'testowy@test.pl';
  //   form.querySelector('[name="tax_country"]').value = 'Polska';
  //   form.querySelector('[name="street"]').value = 'Testowa';
  //   form.querySelector('[name="street_house_no"]').value = '111';
  //   form.querySelector('[name="street_staircase_no"]').value = '';
  //   form.querySelector('[name="city"]').value = 'Testowo';
  //   form.querySelector('[name="postal_code"]').value = '60-000';
  //   form.querySelector('[name="document_type"] option[value="PIT-28"]').setAttribute('selected', 'selected');
  //   form.querySelector('[name="period_year"] option[value="19"]').setAttribute('selected', 'selected');
  //   form.querySelector('[name="period_type"] option[value="M"]').setAttribute('selected', 'selected');
  //   form.querySelector('[name="period_no"]').value = '3';
  //   form.querySelector('[name="tax_amount"]').value = '666,66';
  // });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (validate(e.target)) e.target.submit();
  });

  const btnTypes = form.querySelectorAll('button[data-type]');
  if (btnTypes.length > 0) {
    btnTypes.forEach(item => {
      item.addEventListener('click', (e) => {
        const type = e.target.getAttribute('data-type');
        resetDataTypeBtns();
        e.target.classList.add('active');
        helpers.resetErrors(form);

        if (typeof type !== 'undefined' && type) {
          const itemFieldsWrap = form.querySelector(`#${type}`);
          itemFieldsWrap.classList.remove(classHide);
        }
      });
    });
  }

  // const periodYear = form.querySelector('select[name="period_year"]');
  // if (periodYear) {
  //   console.log('Jestem', periodYear);
  //   periodYear.addEventListener('change',  (e) => {
  //     // const type = e.target.options[e.target.selectedIndex].value;
  //     console.log('SELECT', e.target);
  //   });
  // }

  panelWrap.appendChild(form);

  getPaymentHash();
};

const resetDataTypeBtns = (activeItemKey = -1) => {
  const form = document.querySelector('form#microaccount-pay-form');
  const btnTypes = form.querySelectorAll('button[data-type]');

  btnTypes.forEach((item, key) => {
    const type = item.getAttribute('data-type');

    item.classList.remove('active');
    if (activeItemKey >= 0 && key === activeItemKey) item.classList.add('active');

    if (typeof type !== 'undefined' && type) {
      const itemFieldsWrap = form.querySelector(`#${type}`);

      if (typeof itemFieldsWrap !== 'undefined' && itemFieldsWrap) {
        const inputs = itemFieldsWrap.querySelectorAll('input');

        if (activeItemKey >= 0 && key === activeItemKey) itemFieldsWrap.classList.remove(classHide);
        else itemFieldsWrap.classList.add(classHide);

        if (inputs.length > 0) inputs.forEach(input => input.value = '');
      }
    }
  })
};



export const isPaymentStatusExist = () => {
  const paymentStatusWaiting = document.querySelector('.microaccount-payment-status-waiting');
  const paymentStatusSuccess = document.querySelector('.microaccount-payment-status-success');
  const paymentStatusFailure = document.querySelector('.microaccount-payment-status-failure');

  if (paymentStatusWaiting && paymentStatusSuccess && paymentStatusFailure) {
    const orderId = helpers.getVariable('OrderID');
    if (!orderId) return false;

    const checkPaymentStatus = () => {
      axios.get(`/bm/?check_status=&OrderID=${orderId}`)
        .then((response) => {
          if (typeof response.data.payment_status !== 'undefined') {
            if (response.data.payment_status === 'FAILURE') {
              paymentStatusWaiting.classList.add('alert-hide');
              setTimeout(() => {
                paymentStatusFailure.classList.remove('alert-hide');
              }, 300);

              clearInterval(interval);
            }
            if (response.data.payment_status === 'SUCCESS') {
              paymentStatusWaiting.classList.add('alert-hide');
              setTimeout(() => {
                paymentStatusSuccess.classList.remove('alert-hide');
              }, 300);

              clearInterval(interval);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          clearInterval(interval);
        })
    };

    const interval = setInterval(checkPaymentStatus, 5000);
  }
};

const addPaymentHash = (hash) => {
  const form = document.querySelector('#microaccount-pay-form');
  if (typeof form === 'undefined' || !form || !hash) return false;

  const input = document.createElement('input');
  input.setAttribute('type', 'hidden');
  input.setAttribute('name', 'gph');
  input.value = hash;

  form.appendChild(input);
};

const getPaymentHash = () => {
  const form = new FormData();
  form.set('gph', account.raw);

  axios({
    method: 'post',
    url: '/bm/',
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .then((response) => {
      if (typeof response.data.gph !== 'undefined' && response.data.gph) {
        addPaymentHash(response.data.gph);
      }
    }).catch((error) => { });
};

export const init = (type, id, preparedAccount) => {
  account = preparedAccount;
  idData = {
    type,
    typeSign: (type === 1 ? 'P' : 'N'),
    no: id
  };
  addPanel();
  isPaymentStatusExist();
};